/*
 * RequestsService is responsible to send request data to client-api.
 */

import { Injectable } from '@angular/core';
import { Package } from '@models/package';
import { Request } from '@models/request';
import { BaseService } from '@services/base/base.service';
import { format } from 'date-fns';
import { map } from 'rxjs/operators';

import { HttpService } from '../http/http.service';

@Injectable({
  providedIn: 'root'
})
export class RequestsService {
  constructor(
    public baseService: BaseService,
    public httpService: HttpService
  ) {}

  /*
   * Post request to Api.
   */
  public post(body: any): Promise<Request> {
    return this.httpService
      .post('/requests', this.parseDataForAPI(body))
      .pipe(
        map((response: any) => {
          return response.data;
        })
      )
      .toPromise();
  }

  /*
   * Used to parse subpackage data for api.
   */
  public parseSubPackageDataForAPI(data: any, pack: Package): any {
    try {
      if (
        data &&
        data.dynamicpackage &&
        data.subpackage &&
        parseInt(data.subpackage, 10) >= 0 &&
        pack.subpackage
      ) {
        data.subpackage =
          pack.subpackage[data.subpackage]?.title[0].description;
        return data;
      } else {
        return data;
      }
    } catch (error) {
      return data;
    }
  }

  /*
   * Used to parse trail data for api.
   */
  public parseTrailDataForAPI(data: any): any {
    if (data.services) {
      data.angel_service = data.services.angel ? data.services.angel : false;
      data.guiding = data.services.guiding ? data.services.guiding : false;
      data.mobility = data.services.mobility ? data.services.mobility : false;
    }
    return data;
  }

  /*
   * Used to map between form data and required json data.
   */
  public parseDataForAPI(data: any): any {
    if (data && data.client) {
      data.notes = data.client.notes ? data.client.notes : null;
      delete data.client.notes;
    }
    if (data && data.date) {
      data.date = format(data.date, 'yyyy-MM-dd');
    }
    return data;
  }
}
